<script setup lang="ts">
//import { Vue3Lottie } from 'vue3-lottie'

import { getCurrentInstance } from "vue";

const instance = getCurrentInstance();
const router = instance?.appContext.config.globalProperties.$router;
defineProps<{
  modal: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()

//TODO: Lottie Animation
// Animation data for no permissions
/*const animationData = {
  "v": "5.7.4",
  "fr": 30,
  "ip": 0,
  "op": 60,
  "w": 400,
  "h": 400,
  "nm": "No Access",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Lock",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100 },
        "r": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [0],
              "e": [10]
            },
            {
              "t": 15,
              "s": [10],
              "e": [-10]
            },
            {
              "t": 30,
              "s": [-10],
              "e": [10]
            },
            {
              "t": 45,
              "s": [10],
              "e": [0]
            },
            {
              "t": 60,
              "s": [0]
            }
          ]
        },
        "p": { "a": 0, "k": [200, 200] },
        "a": { "a": 0, "k": [0, 0] },
        "s": { "a": 0, "k": [100, 100] }
      },
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [80, 100] },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 10 }
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.8, 0, 0, 1] },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ]
    }
  ]
}*/

/*const lottieOptions = {
  animationData: animationData,
  loop: true,
  autoPlay: true,
  speed: 1,
}*/

const goBack = () => {
  if (router) {
    router.back()
  }
}

const goHome = () => {
  if (router) {
    router.push('/')
  }
}
</script>

<template>
  <div class="min-h-[400px] flex flex-col items-center justify-center p-8 text-center">
    <!-- Lottie Animation -->
    <!--<div class="w-64 h-64 mb-8">
      <Vue3Lottie
        v-bind="lottieOptions"
        :height="256"
        :width="256"
      />
    </div>-->

    <!-- Text Content -->
    <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">
      Access Denied
    </h2>
    <p class="text-gray-600 dark:text-gray-400 mb-8 max-w-md">
      Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is a mistake.
    </p>

    <!-- Action Buttons -->
    <div class="flex gap-4">
      <button
      v-if="modal == false"
        @click="goBack"
        class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
      >
        Go Back
      </button>
      <button
      v-if="modal == false"
        @click="goHome"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Go to Home
      </button>
      <button
        v-if="modal == true"
        @click="$emit('close')"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Close
      </button>
    </div>
  </div>
</template>